import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useForm, FormProvider } from 'react-hook-form';
import { actionCreators as uploadActionCreators } from '../../../../data/upload/actions';
import { actionCreators as fileProgressActionCreators } from '../../../../../../data/fileProgress/actions';
import { actionCreators as suppliersActionCreators } from '../../../../data/Suppliers/actions';
import { actionCreators as documentsActionCreators } from './data/Documents/actions';
import { actionCreators as deliveryMessageActionCreators } from './data/Message/actions';
import AdminLayout from '../../../../../../components/Layout/AdminLayout';
import { validateForm } from './components/validateForm';
import FormSubmitted from './components/FormSubmitted/';
import Form from './components/Form/';

const CreateDelivery = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  
  const uploadData = useSelector(state => state.Admin.data.upload.data);
  const deliveryMessage = useSelector(state => 
    state.Admin.scenes.Deliveries.scenes.new.data.message.data
  );
  const fileProgress = useSelector(state => state.fileProgress);
  const uploading = Object.values(fileProgress).filter(Boolean).some(({ status }) => status === 'active');

  const initialValues = {
    selectedSuppliers: uploadData.selectedSuppliers || null,
    recipients: [{ email: '', firstName: '', lastName: '', cell: '', companyName: '', organizationNo: '' }],
    gdpr: uploadData.gdpr || {
      hasPersonalDetails: undefined,
      type: '',
      purpose: '',
      noOfEntities: '',
      description: ''
    },
    deliveryMessage: deliveryMessage
  };

  const methods = useForm({
    defaultValues: initialValues,
    mode: 'onBlur',
    resolver: async (values) => {
      const errors = validateForm(values);
      return {
        values: Object.keys(errors).length === 0 ? values : {},
        errors
      };
    }
  });

  const { reset, setValue, formState } = methods;
  const { isSubmitSuccessful } = formState;

  useEffect(() => {
    dispatch(uploadActionCreators.clearSingleUploadData());
    
    const deliveryId = searchParams.get('id');
    if (deliveryId) {
      dispatch(uploadActionCreators.getSingleUpload(deliveryId));
      dispatch(suppliersActionCreators.getSuppliers());
    }

    return () => {
      dispatch(uploadActionCreators.clearSingleUploadData());
    };
  }, [dispatch, searchParams]);

  useEffect(() => {
    reset(initialValues);
  }, [uploadData.selectedSuppliers, deliveryMessage, reset]);

  useEffect(() => {
    if (uploadData.selectedSuppliers && uploadData.selectedSuppliers.length >= 1) {
      dispatch(suppliersActionCreators.selectSupplier(uploadData.selectedSuppliers));
    }
  }, [uploadData.selectedSuppliers, dispatch]);

  useEffect(() => {
    setValue('recipients', initialValues.recipients);
  }, [uploadData.sender, setValue]);

  const deliveryId = uploadData.id;

  return (
    <AdminLayout title="Skapa leverans">
      <FormProvider {...methods}>
        <Form 
          fileProgress={fileProgress}
          uploading={uploading}
          deliveryId={deliveryId}
          postFile={documentsActionCreators.postFile}
          uploadComplete={fileProgressActionCreators.uploadComplete}
          loadDeliveryMessage={deliveryMessageActionCreators.loadDeliveryMessage}
        />
        <FormSubmitted
          submitSucceeded={isSubmitSuccessful}
          reset={reset}
          clearSingleUploadData={() => dispatch(uploadActionCreators.clearSingleUploadData())}
          clearUploadProgress={() => dispatch(fileProgressActionCreators.clearUploadProgress())}
          fileProgress={fileProgress}
        />
      </FormProvider>
    </AdminLayout>
  );
};

export default CreateDelivery;
